// Browser globals expected by legacy jQuery-plugin dependencies.
//
// `bootstrap-daterangepicker` (pulled in by `react-bootstrap-daterangepicker`)
// is a UMD module. In a browser its factory does:
//   var moment = (typeof window.moment != 'undefined') ? window.moment : require('moment');
//   ... factory(moment, (window.jQuery || require('jquery')));
// Under CRA/webpack the `require()` fallbacks returned callable modules. Under
// Vite's dep pre-bundling `require('moment')` can resolve to an ESM-interop
// object, so `moment(...)` throws "moment is not a function". Setting the
// globals here makes the plugin use our known-good instances and never hit the
// broken `require` branch.
//
// IMPORTANT: this module must be imported before anything that pulls in
// `react-bootstrap-daterangepicker` — keep it as the first import in index.jsx.
import moment from 'moment';
import $ from 'jquery';

window.moment = moment;
window.$ = window.jQuery = $;
